module.exports = __webpack_public_path__ + "assets/325075ce2a4aff571f8e040ecea42eac.svg";